import React, { ReactElement, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { GiAtSea } from "react-icons/gi";
import { orderBy } from "lodash";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import "../../style.css";
import { IoSparklesOutline } from "react-icons/io5";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Impression } from "asset-analysis/lib/@types/outcoming/analysis-readable-result";
import useWindowDimensions from "../../../../../../hooks/useWindowDimension";
import GradientText from "../../../../../Logo";
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

type Props = {
  generatedImpressions: Impression[];
  assetId: string;
  switchElement: ReactElement;
};
export default function ImpressionsContent({
  generatedImpressions,
  assetId,
  switchElement,
}: Props) {
  const [showMore, setShowMore] = useState(false);
  const { width } = useWindowDimensions();
  const qntMaxItemsRenderableDefault = width < 576 ? 3 : 6;

  const qntGeneratedImpressions = generatedImpressions.length;

  useEffect(() => {
    setShowMore(false);
  }, [assetId]);

  if (qntGeneratedImpressions > 0) {
    const rendearableImpressions = () => {
      const orderedImpressions = orderBy(
        generatedImpressions,
        ["importantLevel"],
        "desc"
      );
      const qntMaxToRender = showMore
        ? orderedImpressions.length
        : qntMaxItemsRenderableDefault;

      return orderedImpressions.slice(0, qntMaxToRender);
    };

    return (
      <div
        className="card card-dashboard-thirteen"
        id={!isMobile ? "analysis-step-2" : ""}
      >
        <h3>
          <GradientText text={"Lucy AI"} />
          <IoSparklesOutline
            style={{ color: "var(--primary-blue)" }}
            size={25}
          />
        </h3>
        <p className="az-content-text">
          <GradientText
            text={
              "Visualize as impressões que nossa I.A teve ao analisar o ativo."
            }
          />
        </p>

        {switchElement}

        {qntGeneratedImpressions > qntMaxItemsRenderableDefault &&
        width > 768 ? (
          <div style={{ position: "absolute", right: 15 }}>
            <button
              style={{
                backgroundColor: "var(--bg-8)",
                color: "var(--text-1)",
              }}
              className={`btn btn-br-10 ${showMore && "enabled"}`}
              onClick={() => setShowMore(!showMore)}
            >
              {showMore ? (
                <>
                  Ver menos <FaRegEyeSlash size={15} />
                </>
              ) : (
                <>
                  Ver mais <FaRegEye size={15} />
                </>
              )}{" "}
            </button>
          </div>
        ) : (
          <></>
        )}
        <div className="animated fadeInDown">
          <div className="row" id={isMobile ? "analysis-step-2" : ""}>
            {rendearableImpressions().map((item, i) => {
              return (
                <div
                  className={
                    isMobile
                      ? i === 0
                        ? "col-md-4 col-sm-6 col-xs-6 mg-t-0"
                        : "col-md-4 col-sm-6 col-xs-6 mg-t-20"
                      : i < 3
                      ? "col-md-4 col-sm-6 col-xs-6"
                      : "col-md-4 col-sm-6 col-xs-6 mg-t-20"
                  }
                  key={i}
                >
                  <div className="animated fadeInDown">
                    <div className="media">
                      <div
                        className="media-icon"
                        style={{ color: item.iconColor || "black" }}
                      >
                        {item.icon}
                      </div>
                      <div className="media-body">
                        <h6>{item.title}</h6>
                        <label>{item.subtitle}</label>
                      </div>
                    </div>
                    <span>{item.description}</span>
                  </div>
                </div>
              );
            })}
          </div>

          {qntGeneratedImpressions > qntMaxItemsRenderableDefault &&
          width <= 768 ? (
            <div className="d-flex justify-content-center pd-20">
              <button
                style={{
                  backgroundColor: "var(--bg-8)",
                  color: "var(--text-1)",
                }}
                className={`btn btn-br-10 ${showMore && "enabled"}`}
                onClick={() => setShowMore(!showMore)}
              >
                {showMore ? (
                  <>
                    Ver menos <FaRegEyeSlash size={15} />
                  </>
                ) : (
                  <>
                    Ver mais <FaRegEye size={15} />
                  </>
                )}{" "}
              </button>
            </div>
          ) : (
            <></>
          )}
          {getImpressionsColorSubtitles(qntGeneratedImpressions)}
        </div>
      </div>
    );
  } else {
    //No one impressions has generated.
    return (
      <div className="card card-dashboard-thirteen">
        <h3>
          <GradientText text={"Lucy AI"} />
          <IoSparklesOutline
            style={{ color: "var(--primary-blue)" }}
            size={25}
          />
        </h3>
        <p className="az-content-text">
          <GradientText
            text={
              "Visualize as impressões que nossa I.A teve ao analisar o ativo."
            }
          />
        </p>

        {switchElement}

        <div className="animated fadeInDown">
          <div className="d-flex flex-row justify-content-center">
            {<GiAtSea size={70} />}
          </div>
          <div className="d-flex flex-row justify-content-center">
            <p style={{ marginTop: 20, fontSize: 15 }}>
              Lucy teve muita neutralidade em suas impressões, para não te
              confundir, ela preferiu ocultar as impressões.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

const getImpressionsColorSubtitles = (qntGeneratedImpressions: number) => {
  //if less than four impressions has generated, let's keep the subtitle in the bottom (Desktop)
  let mgTop = qntGeneratedImpressions <= 3 ? "26%" : "";

  if (isMobile) {
    return (
      <div className="d-flex flex-row align-items-center mg-t-20 justify-content-center">
        <div className="chart-legend">
          <div>Ótimo</div>
          <div>Bom</div>
          <div>Alerta</div>
          <div>Perigo</div>
        </div>
      </div>
    );
  } else {
    return (
      <div
        className="d-flex flex-row justify-content-center"
        style={{ marginTop: mgTop }}
      >
        <div className="chart-legend" style={{ whiteSpace: "normal" }}>
          <div>Ótima impressão</div>
          <div>Boa impressão</div>
          <div>Alerta</div>
          <div>Impressão de perigo</div>
        </div>
      </div>
    );
  }
};
